import { RoleAccount } from '@/components/role-account';

export default function TeacherAccountScreen() {
  return <RoleAccount accent="#1F5A37" roleLabel="Teacher" />;
}
